/* Page to containing links to the 12 Depts-Xtra departments */
import React, { useState } from "react"
import { Button, Card } from "react-bootstrap"
import { useHistory } from "react-router-dom"
import { useSetDeptGeneralContext } from "../../contexts/DeptCategoryContext"
import { useRedirect } from "../../hooks/Redirect"
import styles from "../../styles/Scene.module.css"
import btnStyles from "../../styles/Button.module.css"
import newpur from "../../assets/newpur.jpg"
import newpur5 from "../../assets/newpur5.jpg"
import newpur9 from "../../assets/newpur9.jpg"
import newpur10 from "../../assets/newpur10.jpg"
import sceneblue6 from "../../assets/sceneblue6.png"
import Col from "react-bootstrap/Col"
import Row from "react-bootstrap/Row"
import TopBox from "../../components/TopBox"
import Info from "./Info"

const DeptsGeneral = () => {
  useRedirect()
  const setDeptGeneral = useSetDeptGeneralContext()
  const [showInfo, setShowInfo] = useState(false)
  const history = useHistory()

  const handleClick = (dept) => {
    setDeptGeneral(dept)
    history.push(`/${localStorage.getItem("projectSlug")}/department/posts`)
  }

  return (
    <div>
      <TopBox title="Department Posts" />
      <Button
        className={`${btnStyles.Button} ${btnStyles.Blue} my-2`}
        onClick={() => history.goBack()}
      >
        Back
      </Button>
      <Button
        className={`float-right py-0 my-2 ${btnStyles.Order} ${btnStyles.Button}`}
        onClick={() => setShowInfo((showInfo) => !showInfo)}
      >
        INFO
      </Button>
      {!showInfo ? "" : <Info />}
      <Card className={` ${styles.Scene} p-0`}>
        <Card.Header className={`${styles.Header} p-0`}>
          <h5
            style={{ textTransform: "uppercase" }}
            className={`text-center pl-5 py-1 ${styles.SubTitle}`}
          >
            DEPARTMENT POSTS
          </h5>
        </Card.Header>
        <Card.Body>
        <Row>
        {/* camera */}
        <Col xs={6} sm={4} md={3} lg={2} className="px-0 mx-0">
        <div className={`${styles.Dept}  px-1 px-sm-3 d-flex align-items-center justify-content-center`}
        style={{background: `url(${newpur9})`,}}
        onClick={() => handleClick("camera")}>
        <h5 className={`text-center ${styles.White2} my-1`} >
        CAMERA
        </h5>
        </div>
        </Col>
        {/* sound */}
        <Col xs={6} sm={4} md={3} lg={2} className="px-0 mx-0">
        <div className={`${styles.Dept} px-1 px-sm-3 d-flex align-items-center justify-content-center`}
        style={{background: `url(${sceneblue6})`,}}
        onClick={() => handleClick("sound")}>
        <h5 className={`text-center ${styles.White2} my-1`} >
        SOUND
        </h5>
        </div>
        </Col>
        {/* loc */}
        <Col xs={6} sm={4} md={3} lg={2} className="px-0 mx-0">
        <div className={`${styles.Dept} px-1 px-sm-3 d-flex align-items-center justify-content-center`}
        style={{background: `url(${sceneblue6})`,}}
        onClick={() => handleClick("location")}>
          <h5 className={`text-center ${styles.White2} my-1`} >
        LOCATION
        </h5>
        </div>
        </Col>
        {/* SCR */}
        <Col xs={6} sm={4} md={3} lg={2} className="px-0 mx-0">
        <div className={`${styles.Dept} px-1 px-sm-3 d-flex align-items-center justify-content-center`}
        style={{background: `url(${newpur5})`,}}
        onClick={() => handleClick("script")}>
          <h5 className={`text-center ${styles.White2} my-1`} >
        SCRIPT
        </h5>
        </div>
        </Col>
        {/* art */}
        <Col xs={6} sm={4} md={3} lg={2} className="px-0 mx-0">
        <div className={`${styles.Dept} px-1 px-sm-3 d-flex align-items-center justify-content-center`}
        style={{background: `url(${sceneblue6})`,}}
        onClick={() => handleClick("art")}>
          <h5 className={`text-center ${styles.White2} my-1`} >
        ART
        </h5>
        </div>
        </Col>
        {/* mak */}
        <Col xs={6} sm={4} md={3} lg={2} className="px-0 mx-0">
        <div className={`${styles.Dept} px-1 px-sm-3 d-flex align-items-center justify-content-center`}
        style={{background: `url(${newpur})`,}}
        onClick={() => handleClick("make-up")}>
          <h5 className={`text-center ${styles.White2} my-1`} >
        MAKEUP
        </h5>
        </div>
        </Col>
        {/* war */}
        <Col xs={6} sm={4} md={3} lg={2} className="px-0 mx-0">
        <div className={`${styles.Dept} px-1 px-sm-3 d-flex align-items-center justify-content-center`}
        style={{background: `url(${sceneblue6})`,}}
        onClick={() => handleClick("wardrobe")}>
          <h5 className={`text-center ${styles.White2} my-1`} >
        WARDROBE
        </h5>
        </div>
        </Col>
        {/* cas */}
        <Col xs={6} sm={4} md={3} lg={2} className="px-0 mx-0">
        <div className={`${styles.Dept} px-1 px-sm-3 d-flex align-items-center justify-content-center`}
        style={{background: `url(${newpur5})`,}}
        onClick={() => handleClick("casting")}>
          <h5 className={`text-center ${styles.White2} my-1`} >
        CASTING
        </h5>
        </div>
        </Col>
        {/* pos */}
        <Col xs={6} sm={4} md={3} lg={2} className="px-0 mx-0">
        <div className={`${styles.Dept} px-1 px-sm-3 d-flex align-items-center justify-content-center`}
        style={{background: `url(${newpur})`,}}
        onClick={() => handleClick("post")}>
          <h5 className={`text-center ${styles.White2} my-1`} >
        POST/VFX
        </h5>
        </div>
        </Col>
        {/* PRO */}
        <Col xs={6} sm={4} md={3} lg={2} className="px-0 mx-0">
        <div className={`${styles.Dept} px-1 px-sm-3 d-flex align-items-center justify-content-center`}
        style={{background: `url(${sceneblue6})`,}}
        onClick={() => handleClick("production")}>
          <h5 className={`text-center ${styles.White2} my-1`} >
        PRODUCTION
        </h5>
        </div>
        </Col>
        {/* stunts */}
        <Col xs={6} sm={4} md={3} lg={2} className="px-0 mx-0">
        <div className={`${styles.Dept} px-1 px-sm-3 d-flex align-items-center justify-content-center`}
        style={{background: `url(${sceneblue6})`,}}
        onClick={() => handleClick("stunts")}>
          <h5 className={`text-center ${styles.White2} my-1`} >
        STUNTS/SFX
        </h5>
        </div>
        </Col>
        {/* el */}
        <Col xs={6} sm={4} md={3} lg={2} className="px-0 mx-0">
        <div className={`${styles.Dept} px-1 px-sm-3 d-flex align-items-center justify-content-center`}
        style={{background: `url(${newpur9})`,}}
        onClick={() => handleClick("electric")}>
          <h5 className={`text-center ${styles.White2} my-1`} >
        ELECTRIC/GRIP
        </h5>
        </div>
        </Col>
        </Row>
        </Card.Body>
      </Card>
    </div>
  )
}

export default DeptsGeneral
